
import Env from 'env'

import * as Form from 'tsui/Form';
import { PageHeaderTheme } from './ThemeElements';

import * as UE from 'tsui/UiElements'
import { ThemeBase } from '../tsui/ThemeBase';

import device from "current-device"


// export const dialogBorderStyle = '1px solid #91cbd8';
export const dialogBorderStyle = '1px solid #a38646';
export class ThemeInstance extends ThemeBase {

    isDark = false

    themeColor = '#e8a412'


    muiPrimaryMain = this.isDark ? '#90caf9' : '#29b6f6'
    muiPrimaryLight = this.isDark ? '#e3f2fd' : '#4fc3f7'
    muiPrimaryDark = this.isDark ? '#42a5f5' : '#42a5f5'


    cardMaxWidth = 345;
    cardBoxShadow = 'none';
    cardBorderRadius = 0;
    cardBackdropFilter = "blur(5px)";
    cardPadding =  3;
    cardTextTransform = 'initial';

    cardBoxShadowHover = 18;
    cardBackgroundColor = 'white';

    orderModalBoxWidth = 700;
    orderModalBoxHeight = 'auto';
    orderModalBoxBorderRadius = 8;
    orderModalBoxBorderStyle = 'none';
    orderModalBoxBackgroundColor = 'white';
    orderModalBoxPadding = 5;

    pageToolbarHeight = 20;
    // formGridSpacing = 1

    buttonHoverColor = '#d09310';
    buttonHoverColorGradient = 'linear-gradient(96.31deg, #FCB131 9.36%, #f69d04 57.75%)';
    buttonColor = 'linear-gradient(96.31deg, #FBC04C 9.36%, #FCB131 57.75%)';
    disabledButtonColor = 'linear-gradient(96.31deg, #242a37 9.36%, #242737 57.75%)';

    //pageBackgroundColor = '#ffffff';
    pageDarkModeTextColor = '#ffffff';

    
    inputTextBackgroundColor = '#ffffff';
    inputReadonlyBackgroundColor = '#eeeeee';

        getFormButtonSize(size?: Form.FormSizeType) {
        switch(size) {
        case 'sm': return 80;
        case 'md': return 180;
        case 'lg': return 300;
        case 'xl': return 400;
        default: return '100%';
        }
    }

    homePageHeaderTheme = new PageHeaderTheme();

    // Page Layout
    pageMinWidth = 900
    pageMinHeight =768

    pageHorzMargin = 1
    pageTopMargin = 1
    pageBottomMargin = 1

    pageHeaderHeight = 60

    pageLogoWidth = Env.isMobile ? 130 : 200
    pageLogoHeight = Env.isMobile ? 25 : 35
    pageLogoLeft = Env.isMobile ? 15 : 25
    pageLogoTop = Env.isMobile ? 30 : 50

    pageLangSelectorTop = Env.isMobile ? 10 : 26
    pageLangSelectorRight = Env.isMobile ? 65 : 15
    pageLangSelectorInsideWidth = Env.isMobile ? 102 : 106
    pageLangSelectorInsideTop = Env.isMobile ? 16 : 20

    pageAuthButtonWidth = Env.isMobile ? 60 : 120
    pageAuthButtonHeight = Env.isMobile ? 30 : 40
    pageAuthButtonLeft = Env.isMobile ? 0 : 10
    pageAuthButtontop = Env.isMobile ? 28 : 43
    pageAuthButtonPaddingRight = Env.isMobile ? 5 : 10
    
    pageUserAuthContainerRight = Env.isMobile ? 10 : 130


    // pageBackgroundColor = '#ffffff'
    // pageBackgroundColor = '#71797E'
    pageBackgroundColor = '#2f3742'
    dataGridTextColor = 'white'
    pageTextColor = 'black' // VS Code dark theme color


    tableOddRowColor = '#ff0000'
    tableRowHeight = 52
    tableActionButtonWidth = this.tableRowHeight;
    tableActionButtonHeight = this.tableRowHeight;


    dialogBorderRadius = 4;
    dialogBorderWidth = 2;
    dialogBorderStyle = 'solid';
    dialogMessageTransform = 'translateY(-8vh)';

    dialogTextColor = 'black'
    dialogBorder = new UE.UiBorder({color: this.muiPrimaryMain, width: 1, radius: 4})
    dialogHeight = '90%'; // Env.isMobile ? '90%' :'90%'


    dialogBorderColor!: string;
    dialogBackgroundColor!: string;

    cssDialogBorder() {
        return {
            borderRadius: this.dialogBorderRadius,
            borderColor: this.dialogBorderColor,
            borderWidth: this.dialogBorderWidth,
            borderStyle: this.dialogBorderStyle,
        }
    }

    cssButtonShadow() {
        return {
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        }
    }

    cssButtonHover() {
        return {
            "&:hover": {
                border: "2px solid #25afce66",
            }
        }
    }
    // dialogBorderRadius = 4;
    // dialogBorderWidth = 2;
    // dialogBorderStyle = 'solid';
    // dialogMessageTransform = 'translateY(-8vh)';

    // dialogBorderColor!: string;
    // dialogBackgroundColor!: string;
    
    // cssDialogBorder() {


    //     return {
    //         borderRadius: this.dialogBorderRadius,
    //         borderColor: this.dialogBorderColor,
    //         borderWidth: this.dialogBorderWidth,
    //         borderStyle: this.dialogBorderStyle,
    //     }
    // }

};